import { Component, OnInit,EventEmitter,Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../service/frappe/auth.service';
import { MessageService } from 'primeng/api';
import { VendorTsService } from '../../../service/vendor/vendor.ts.service';
import { Router } from '@angular/router';
import { UserService } from '../../../service/user-service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @Output() userFoundChange = new EventEmitter<boolean>();

  loggedInUser: string = '';
  vendorCode: string = '';
  business_email: string = '';
  userProfile: any = {};
  changePasswordForm: FormGroup;
  is_registration:boolean=false
  is_approve:boolean=false
  isVendor=false

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private vendorService: VendorTsService,
    private router: Router,
    private userService: UserService,
  ) {
    this.changePasswordForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]]
    }, { validator: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    this.authService.getLoggedInUser().then(username => {
      this.loggedInUser = username;
      this.getUserProfile(this.loggedInUser);
      this.getVendorCode(this.loggedInUser);
    });

    this.vendorService.checkIfVendor().then((res)=>{
      this.is_registration=res.message.is_registration
      this.is_approve=res.message.is_approve
    }).catch((error)=>{
      console.log(error)
    })
  }

  getUserProfile(user: any) {
    this.authService.getUserDetail(this.loggedInUser).then(response => {
      this.userProfile = response.message;
    });
  }

  getVendorCode(user: any) {
    this.authService.getVendorCode(this.loggedInUser).then(vc => {
      if (vc.message.length > 0) {
        this.isVendor=true
        this.vendorCode = vc.message[0].vendor_code || "";
        this.business_email=vc.message[0].business_email || "";
      }
      else{
        this.business_email=this.loggedInUser
      }
    });
  }
  passwordMatchValidator(formGroup: AbstractControl) {
    const newPassword = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { mismatch: true };
  }

  submitNewPassword() {
    if (this.changePasswordForm.valid) {
      const newPassword = this.changePasswordForm.value.newPassword;
      this.authService.updatePassword(newPassword)
        .then((response:any) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
          if (!this.is_registration) {
            setTimeout(() => { this.router.navigate(['/portal/vendor/registration']) }, 1500)
          }else if (this.is_approve) {
            const userFound = true;
            this.userService.setUserFound(userFound);
            this.userFoundChange.emit(userFound);
            setTimeout(() => { this.router.navigate(['/']) }, 1500)
          }
          this.changePasswordForm.reset();
        }).catch((error) => {
          console.log(error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while Changing Password .' });
          this.changePasswordForm.reset();
        })
    }
  }


}
